export default "__VITE_ASSET__BvYBy0zD__"